<ng-content select="[title]"></ng-content>
<ul>
  @for(card of cards; track $index) {
  <li>
    <img role="presentation"
         auto="none"
         size="icon"
         [use]="card">
  </li>
  }
</ul>
<ng-content></ng-content>
